import { Injectable } from '@angular/core';
import { AuthenticationServiceAsbtract } from '@vfde-fe/ngx-lib/services/core-authentication';
import { TRACKING_LOGGING_STATUS } from '@vfde-fe/ngx-lib/core';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
/** AuthService */
@Injectable({
    providedIn: 'root',
  })
export class AuthService extends AuthenticationServiceAsbtract {

    // jwtToken for nil service returned
    private jwtToken;
    /** inject storage service and user service
     * constructor
     * @param routesUtilsService
     */
    public constructor (
        private routesUtilsService: RoutesUtilsService,
    ) {
        super();
    }
    /**
     * set jwtToken
     * @param {string} _jwtToken
     */
    public setJwtToken (_jwtToken: string) {
        this.jwtToken = _jwtToken;
    }

    /**
     * get jwtToken
     */
    public getJwtToken () {
        return this.jwtToken;
    }

    /**
     * reset jwtToken
     */
    public resetJwtToken () {
        this.jwtToken = null;
    }
    /** isAuthenticated */
  public isAuthenticated (): boolean {
        return true;
    }
    /** getTrackingLoggedInStatus */
    public getTrackingLoggedInStatus (): string {
        return this.jwtToken ? TRACKING_LOGGING_STATUS.LOGGED_IN : TRACKING_LOGGING_STATUS.NOT_LOGGED_IN;
    }
    /**
     * logout the user
     * @param logoutUrl
     */
    public logout (logoutUrl) {
        this.routesUtilsService.navigateToURL(logoutUrl);
    }
}
